import { Vue, Component, Prop } from 'vue-property-decorator'
import Breadcrumb from '~/components/page/Breadcrumb'
import LinkItem from '~/types/LinkItem'
import CategoryHeader from '~/components/page/category/CategoryHeader'
import BasketHeader from '~/components/page/basket/BasketHeader'
import HeaderType from '~/types/enum/HeaderType'
import OrderHeader from '~/components/page/order/OrderHeader'
import WishlistHeader from '~/components/page/wishlist/WishlistHeader'
import SearchHeader from '~/components/page/search/SearchHeader'
import NewsHeader from '~/components/page/news/NewsHeader'
import StockHeader from '~/components/page/stock/StockHeader'
import CatalogSectionsHeader from '~/components/page/catalogSections/CatalogSectionsHeader'
import DiseasesHeader from '~/components/page/diseases/DiseasesHeader'
import PopularHeader from '~/components/page/popular/PopularHeader'
import SaleHeader from '~/components/page/sale/SaleHeader'
import PharmaciesHeader from '~/components/page/pharmacies/PharmaciesHeader'
import PharmacyDetailHeader from '~/components/page/pharmacyDetail/PharmacyDetailHeader'
import OrderDetailHeader from '~/components/page/orderDetail/OrderDetailHeader'
import OrderPaymentResultHeader from '~/components/page/orderPaymentResult/OrderPaymentResultHeader'
import PresetHeader from '~/components/page/preset/PresetHeader'
import ReviewsHeader from '~/components/page/reviews/ReviewsHeader'
import CategoriesHeader from '~/components/page/categories/CategoriesHeader'
import UserProductHeader from '~/components/page/userProductList/UserProductHeader'
import NoveltiesHeader from '~/components/page/novelties/NoveltiesHeader'
import BannerHeader from '~/components/page/banner/BannerHeader'
import LandingPageHeader from '~/components/page/landingPage/LandingPageHeader'

@Component
export default class PageHeader extends Vue {
  @Prop({ type: Boolean, default: true })
  readonly isShowBreadcrumb: boolean = true

  @Prop({ type: Array, default: () => ([]) })
  readonly breadcrumb?: LinkItem[]

  @Prop({ type: Number, default: HeaderType.Default })
  readonly typeHeader?: number

  @Prop({ type: Boolean, default: true })
  readonly isShowBasketClearButtons: boolean = true

  renderDefault () {
    return (
      <div></div>
    )
  }

  renderHeader () {
    switch (this.typeHeader) {
      case HeaderType.Category:
        return (<CategoryHeader />)
      case HeaderType.Basket:
        return (<BasketHeader {...{
          props: {
            isShowBasketClearButtons: this.isShowBasketClearButtons
          }
        }}
        />)
      case HeaderType.Product:
        return this.renderDefault()
      case HeaderType.Order:
        return (<OrderHeader />)
      case HeaderType.OrderDetail:
        return (<OrderDetailHeader />)
      case HeaderType.Wishlist:
        return (<WishlistHeader />)
      case HeaderType.UserProduct:
        return (<UserProductHeader />)
      case HeaderType.Search:
        return (<SearchHeader />)
      case HeaderType.News:
        return (<NewsHeader />)
      case HeaderType.NewsDetail:
        return this.renderDefault()
      case HeaderType.Stock:
        return (<StockHeader />)
      case HeaderType.StockDetail:
        return this.renderDefault()
      case HeaderType.CatalogSections:
        return (<CatalogSectionsHeader />)
      case HeaderType.Diseases:
        return (<DiseasesHeader />)
      case HeaderType.Popular:
        return (<PopularHeader />)
      case HeaderType.Sale:
        return (<SaleHeader />)
      case HeaderType.Pharmacies:
        return (<PharmaciesHeader />)
      case HeaderType.PharmacyDetail:
        return (<PharmacyDetailHeader />)
      case HeaderType.OrderPaymentResult:
        return (<OrderPaymentResultHeader />)
      case HeaderType.Preset:
        return (<PresetHeader />)
      case HeaderType.Reviews:
        return (<ReviewsHeader />)
      case HeaderType.Categories:
        return (<CategoriesHeader />)
      case HeaderType.Novelties:
        return (<NoveltiesHeader/>)
      case HeaderType.Banner:
        return (<BannerHeader/>)
      case HeaderType.LandingPage:
        return (<LandingPageHeader/>)
      default: {
        return this.renderDefault()
      }
    }
  }

  renderBreadcrumb () {
    if (this.isShowBreadcrumb) {
      return (
        <div class="page-header__breadcrumb">
          <Breadcrumb {...{
            props: {
              items: this.breadcrumb
            }
          }} />
        </div>
      )
    }
  }

  render () {
    return (
      <div class="page-header">
        <div class="page-header__container">
          {this.renderBreadcrumb()}
          {this.renderHeader()}
        </div>
      </div>
    )
  }
}
